import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import sprintf from 'i18next-sprintf-postprocessor';
import enJson from './language/en.json';
import viJson from './language/vi.json';
import thJson from './language/th.json';
import myJson from './language/my.json';
import idJson from './language/id.json';

const resources = {
    en: {
        translation: enJson
    },
    vi: {
        translation: viJson
    },
    th: {
        translation: thJson
    },
    my: {
        translation: myJson
    },
    id: {
        translation: idJson
    }
}

i18next
    .use(sprintf)
    .use(initReactI18next)
    .init({
        resources,
        lng: 'vi',
        keySeparator: '.',
        interpolation: {
            escapeValue: false
        },
        react: {
            wait: true,
        },
        overloadTranslationOptionHandler: sprintf.overloadTranslationOptionHandler
    })

export default i18next;